import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Reloads the record responsible persons once a bulk update has been applied.
 */
export const reloadResponsiblePersonsOnSubmitSuccess = store.effects.create(
  (feature: Plugin['feature'], _: Plugin) =>
    feature.actions.submit.success.observe().pipe(
      rxjs.switchMap(action =>
        ec.models.CollectionProducer.getEc$(
          ec.Name.Predefined.SpaceResponsiblePerson,
          { waitUntilReady: true },
        ).pipe(
          rxjs.take(1),
          rxjs.map(responsiblePersonsEc =>
            responsiblePersonsEc.plugins.currentListPlugin.feature.actions.load
              .from(action)
              .create(),
          ),
        ),
      ),
    ),
)
